import AccordionMenuItem from './AccordionMenuItem';

export default AccordionMenuItem;
